// src/services/profileRequests.api.js
import api, { API_BASE_URL } from "./api.js";

/**
 * NOTE:
 * - Assumes `api` is an axios instance with withCredentials:true
 * - Endpoints used:
 *   GET  `${API_BASE_URL}/profile-settings/requests/my`
 *   POST `${API_BASE_URL}/profile-settings/requests`
 *   GET  `${API_BASE_URL}/profile-settings/me`                <-- must return user personal fields
 *   POST `${API_BASE_URL}/profile-settings/update-personal`   <-- update name & phone
 */

// ============================
// GET my requests
// ============================
export const getMyProfileRequests = async () => {
  try {
    const res = await api.get(`${API_BASE_URL}/profile-settings/requests/my`);
    return res.data?.data; // { data: [...] }
  } catch (error) {
    throw (
      error?.response?.data || {
        message: "Failed to load profile change requests",
      }
    );
  }
};

// ============================
// CREATE request
// ============================
// export const createProfileRequest = async (payload) => {
//   /**
//    * payload = {
//    *   field: "faculty" | "level" | "universtyID",
//    *   newValue: string | number,
//    *   reason: string
//    * }
//    */
//   try {
//     const res = await api.post(
//       `${API_BASE_URL}/profile-settings/requests`,
//       payload,
//     );
//     return res.data; // { message, data }
//   } catch (error) {
//     throw (
//       error?.response?.data || {
//         message: "Failed to submit profile change request",
//       }
//     );
//   }
// };
export const createProfileRequest = async (payload) => {
  /**
   * payload = {
   * field: "faculty" | "level" | "universtyID",
   * newValue: string | number,
   * reason: string
   * }
   */
  try {
    const res = await api.post(
      `${API_BASE_URL}/profile-settings/requests`,
      payload,
    );
    return res.data; // { message, data }
  } catch (error) {
    // 1. رسالة افتراضية لو السيرفر ماردش
    let errMsg = "حدث خطأ أثناء تقديم طلب التعديل. يرجى المحاولة مرة أخرى.";

    // 2. تفتيش في الـ errors اللي راجعة من Joi
    if (error.response?.data?.errors) {
      const validationErrors = error.response.data.errors;
      // بنجيب أول حقل فيه مشكلة
      const firstErrorKey = Object.keys(validationErrors)[0];
      
      if (firstErrorKey && validationErrors[firstErrorKey].length > 0) {
        // بناخد الرسالة المخصصة اللي كتبناها بالعربي
        errMsg = validationErrors[firstErrorKey][0];
      }
    } 
    // 3. لو مفيش errors بس في message عامة من الباك إند (زي: "You already submitted a request in this term.")
    else if (error.response?.data?.message) {
      errMsg = error.response.data.message;
    } 
    // 4. لو خطأ في النت 
    else if (error.message) {
      errMsg = error.message;
    }

    // بنرمي الإيرور متقشر وجاهز للـ Component عشان يعرضه فوراً
    throw new Error(errMsg);
  }
};
// ============================
// GET current profile (for initial values)
// ============================
// export const getMyProfile = async () => {
//   try {
//     const res = await api.get(`${API_BASE_URL}/profile-settings/me`);
//     return res.data; // expected structure: { data: { name, phone, faculty, level, universtyID, ... } }
//   } catch (error) {
//     throw error?.response?.data || { message: "Failed to load profile" };
//   }
// };

// ============================
// UPDATE personal (name, phone)
// ============================
export const updatePersonal = async (payload) => {
  /**
   * payload = { name: string, phone: string }
   */
  try {
    const res = await api.post(
      `${API_BASE_URL}/profile-settings/requests/update-personal`,
      payload,
    );
    return res.data; // { message, data: updatedUser }
  } catch (error) {
    throw (
      error?.response?.data || { message: "Failed to update personal info" }
    );
  }
};

// export default {
//   getMyProfileRequests,
//   createProfileRequest,
//   getMyProfile,
//   updatePersonal,
// };

export const updatePassword = async (payload) => {
  try {
    const res = await api.post(
      `${API_BASE_URL}/profile-settings/update-password`,
      payload,
    );
    return res.data;
  } catch (error) {
    const msg = error?.response?.data?.message || "Failed to update password";
    // ارمي Error حقيقي
    throw new Error(msg);
  }
};

export const SendOTP = async (otpType) => {
  // resetPassword
  try {
    // POST to: /profile-settings/OTP/:otpType
    const res = await api.post(
      `${API_BASE_URL}/profile-settings/OTP/${otpType}`,
    );

    return res.data; // { message, remainingAttempts? }
  } catch (error) {
    const msg =
      error?.response?.data?.message || error?.message || "Failed to send OTP";
    // always throw a real Error
    throw new Error(msg);
  }
};

export const resetPasswordWithOTP = async (otpData) => {
  try {
    const res = await api.post(
      `${API_BASE_URL}/profile-settings/reset-password-with-otp`,
      { otpData }, // لازم تبعتها كده علشان الباك اند
    );
    return res.data;
  } catch (error) {
    const msg =
      error?.response?.data?.message ||
      error?.message ||
      "Failed to reset password";

    throw new Error(msg);
  }
};

export const confirmDeleteAccountAPI = async () => {
  try {
    const res = await api.patch(
      `${API_BASE_URL}/profile-settings/confirm-delete-account`,
    );
    return res.data; // { message }
  } catch (error) {
    const msg =
      error?.response?.data?.message ||
      error?.message ||
      "Failed to delete account";
    throw new Error(msg);
  }
};

export const toggleNotificatio = async () => {
  try {
    const res = await api.patch(
      `${API_BASE_URL}/profile-settings/toggle-notification`,
    );
    return res.data; // { message, notificationStatus }
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to toggle notification",
    );
  }
};
